<template>
  <section class="toggle-container" v-auto-animate :class="{ open: showGroup }">
    <div class="toggle-row" @click="showGroup = !showGroup">
      <slot name="toggle" />
      <slot name="toggle-label">
        <template v-if="price != null">
          <price-row :price="price" :type="priceType">
            <template #label>
              <span v-if="toggleLabel" class="label toggle-label">
                <span> {{ toggleLabel }} </span>
                <Icon :icon="icon" size="sm" />
              </span>
            </template>
          </price-row>
        </template>
        <template v-else>
          <span v-if="toggleLabel" class="label toggle-label">
            <span> {{ toggleLabel }} </span>
            <icon :icon="icon" size="sm" />
          </span>
        </template>
      </slot>
    </div>
    <!-- <transition name="collapse-group"> -->

    <ul v-if="showGroup" ref="toggleContent" class="toggle-group" :aria-expanded="showGroup">
      <slot name="toggle-content" />
    </ul>

    <!-- </transition> -->
  </section>
</template>

<script setup>
import { watch } from 'vue';
import { ref, computed } from 'vue';
import PriceRow from './PriceRow.vue';
import Icon from '../../../../vue-elements/icon/Icon.vue';

const props = defineProps(
  {
    startOpen: {
      type: Boolean,
      default: false,
    },
    toggleLabel: {
      type: [Boolean, String],
      default: 'Bekijk prijsopbouw',
    },
    price: {
      type: [Number, String],
      default: null,
    },
    priceType: {
      type: String,
      default: null,
    },
  }
)

const showGroup = ref(props.startOpen);

const icon = computed(() => {
  return showGroup.value ? 'chevron-up' : 'chevron-down';
});
const emit = defineEmits(['toggle', 'open', 'close']);

watch(showGroup, (showing) => {
  emit('toggle');

  if (showing) {
    if (showing) {
      emit('open');
    } else {
      emit('close');
    }
  }
});

</script>

<style lang="scss" scoped>
@use "assets/scss/_helpers/display";
@use 'assets/scss/_variables/colors';
@use 'assets/scss/_helpers/typography';

.toggle-row {
  @include display.flex-col-start;
  background-color: colors.$element-base;
  cursor: pointer;

  .toggle-label {
    @include display.flex-row-start;
    @include typography.link-default;

    color: #171717;
    border-bottom-color: #afb7ba;

    .icon-element {
      background-color: currentColor;
      margin-left: 8px;
    }
  }
}

.toggle-group {
  overflow: hidden;
}

.collapse-group-enter-active,
.collapse-group-leave-active {
  transition: all 0.25s cubic-bezier(0.63, 0.3, 0.31, 0.68);
  max-height: var(--contentHeight);
}

.collapse-group-enter-from,
.collapse-group-leave-to {
  max-height: 0;
}
</style>
